import React, { useState, useEffect } from "react";
import SideBar from "./SideBar";
import Navb from "../../components/navbar/Navb";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import axios from "axios";
import "./dashboard.css";
import Arrow from "./arrow.svg";
import { Link } from "react-router-dom";
import API_URL from "../../constants";
const Viewjobs = () => {
  const [job, setJob] = useState();
  const [jobsId, setJobsId] = useState();
  const [editingJobId, setEditingJobId] = useState(null);
  const [editing, setEditing] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [candidate, setCandidate] = useState([]);
  const [formData, setFormData] = useState({});
  const url = window.location.href;
  const id = url.substring(url.lastIndexOf("/") + 1);
  const [status, setStatus] = useState("all");
  const [addnewskill, setAddnewskill] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [clickedSkills, setClickedSkills] = useState([]);
  const [addnewkeyword, setAddnewkeyword] = useState(false);
  const [selectedKeywords, setSelectedKeywords] = useState([]);
  const [clickedKeywords, setClickedKeywords] = useState([]);

  const fetchData = async () => {
    try {
      const url = window.location.href;
      const id = url.substring(url.lastIndexOf("/") + 1);
      const response = await axios.get(
        `${API_URL}/applications/job_details`,
        { params: { job_id: id } }
      );
      setSubmit(false);
      setJob(response.data.job);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [submit]);
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const fetchCandidates = async () => {
      try {
        const respo = await axios.get(
          `${API_URL}/admin/jobs/${job.job_id}/candidates`,
          { params: { status } } // Use status state here
        );
        setCandidate(respo.data.candidates);
      } catch (error) {
        console.error("Error:", error.request);
      }
    };

    fetchCandidates();
  }, [id]);

  // Function to handle fetching candidates based on status

  const handleStatusChange = (newStatus) => {
    setStatus(newStatus); // Update status state when status changes
  };
  useEffect(() => {
    console.log("job:", job);
  }, [job]);
  // console.log("job:", job);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("formData", formData);
    // const { id, job_id, updatedAt, createdAt,...formDataWithoutTimestamps } =
    //   formData;
    const {
      id,
      job_id,
      updatedAt,
      createdAt,
      skills,
      keywords,
      ...formDataWithoutTimestamps
    } = formData;
    const dataToChange = {
      ...formDataWithoutTimestamps,
      skills: clickedSkills,
      keywords: clickedKeywords,
    };
    console.log("dataToChange", dataToChange);
    console.log("dataclickedSkills", clickedSkills);
    // const dataToChange = { ...formDataWithoutTimestamps };
    try {
      const resp = await axios.post(
        `${API_URL}/admin/jobs/${editingJobId}`,
        dataToChange
      );
      console.log("resp:", resp);
      setSubmit(true);
      setEditing(false);
      // fetchData();
    } catch (error) {
      if (error.response) {
        // The server returned an error response
        console.error("Server Error:", error.response.data);
        console.error("Status Code:", error.response.status);
      } else if (error.request) {
        // The request was made but no response was received
        console.error("Network Error:", error.request);
      } else {
        // Something happened in setting up the request that triggered an error
        console.error("Request Error:", error.message);
      }
    }
    console.log("formData", formData);
    console.log("editingJobId", editingJobId);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("name, value", name, value);
    if (name === "keywords") {
      // Split the input value into an array of keywords
      const keywordsArray = value
        .split(/[, ]+/)
        .map((keyword) => keyword.trim());
      setFormData({ ...formData, [name]: keywordsArray });
    } else if (name === "skills") {
      // Split the input value by both commas and spaces
      const skillsArray = value.split(/[, ]+/).map((skill) => skill.trim());
      setFormData({ ...formData, [name]: skillsArray });
    } else {
      setFormData({ ...formData, [name]: value });
    }
    console.log("formData", formData);
    console.log("Updated form data:", { ...formData, [name]: value });
  };
  const handleEditClick = (jobId) => {
    setFormData(job);
    setEditingJobId(jobId);
    setEditing(true);
    setClickedSkills(job.skills);
    setClickedKeywords(job.keywords);
  };

  const handleCancelClick = (jobId) => {
    setEditing(null);
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { month: "long", day: "numeric", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const fetchToken = async () => {
    try {
      const url = window.location.href;
      const id = url.substring(url.lastIndexOf("/") + 1);
      const response = await axios.get(
        `${API_URL}/admin/get_token`,
        {
          params: { type: "skills" },
        }
      );
      console.log("response", response);

      // Update selected skills with the skills received
      setSelectedSkills(response.data.tokens);
      console.log("selectedSkills", selectedSkills);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    fetchToken();
  }, []);
  const handleSkillClick = (event, skill) => {
    event.preventDefault(); // Prevent form submission
    console.log("ClickedSkillstop", clickedSkills);
    // Check if the skill is already in the clickedSkills array
    const isSkillClicked = clickedSkills.includes(skill);

    if (isSkillClicked) {
      // If the skill is already clicked, remove it from the clickedSkills array
      setClickedSkills(clickedSkills.filter((s) => s !== skill));
    } else {
      // If the skill is not clicked, add it to the clickedSkills array
      setClickedSkills([...clickedSkills, skill]);
    }
    console.log("ClickedSkills1", clickedSkills);
  };
  useEffect(() => {
    console.log("ClickedSkills", clickedSkills);
  }, [clickedSkills]);
  // useEffect(() => {
  //   setClickedSkills([]);
  // }, [editing]);

  const handleSkillPostData = async (event) => {
    event.preventDefault(); // Prevent the default form action
    console.log("skilldata", formData.skills);
    try {
      const sendData = {
        type: "skills",
        tokens: formData.skills,
      };
      const response = await axios.post(
        `${API_URL}/admin/add_token`,
        sendData
      );
      console.log("response", response);
      fetchToken();
    } catch (error) {
      console.log(error);
    }
  };

  const fetchkeywordToken = async () => {
    try {
      // const url = window.location.href;
      // const id = url.substring(url.lastIndexOf("/") + 1);
      const response = await axios.get(
        `${API_URL}/admin/get_token`,
        {
          params: { type: "keywords" },
        }
      );
      console.log("response", response);

      // Update selected skills with the skills received
      setSelectedKeywords(response.data.tokens);
      console.log("selectedKeywords", selectedKeywords);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    fetchToken();
  }, []);
  useEffect(() => {
    fetchkeywordToken();
  }, []);
  const handleKeywordClick = (event, keyword) => {
    event.preventDefault(); // Prevent form submission
    console.log("ClickedKeywordstop", clickedKeywords);
    // Check if the skill is already in the clickedSkills array
    const isKeywordClicked = clickedKeywords.includes(keyword);

    if (isKeywordClicked) {
      // If the skill is already clicked, remove it from the clickedSkills array
      setClickedKeywords(clickedKeywords.filter((s) => s !== keyword));
    } else {
      // If the skill is not clicked, add it to the clickedSkills array
      setClickedKeywords([...clickedKeywords, keyword]);
    }
    console.log("ClickedKeywords1", clickedKeywords);
  };
  useEffect(() => {
    console.log("ClickedKeywords", clickedKeywords);
  }, [clickedKeywords]);
  // useEffect(() => {
  //   setClickedSkills([]);
  // }, [editing]);

  const handleKeywordPostData = async (event) => {
    event.preventDefault(); // Prevent the default form action
    console.log("keyworddata", formData.keywords);
    try {
      const sendData = {
        type: "keywords",
        tokens: formData.keywords,
      };
      const response = await axios.post(
        `${API_URL}/admin/add_token`,
        sendData
      );
      console.log("response", response);
      fetchkeywordToken();
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <Navb />
      <div className="dashboard">
        <SideBar />
        <section className="rightBar">
          {!editing && (
            <div className="center">
              <button
                className="submitButton"
                onClick={() => handleEditClick(job.job_id)}
              >
                Edit
              </button>
            </div>
          )}
          <div className="jobItem">
            <div className="jobActions">
              {job ? (
                editing ? (
                  <>
                    <Form onSubmit={handleSubmit}>
                   
                      <div className="allInputField">
                        <InputGroup className="mb-3">
                          <div className="wrapper_input">
                            <div className="jobTitle">Company Name: </div>

                            <Form.Control
                              className="inputField"
                              placeholder={job.company_name}
                              aria-label="name"
                              aria-describedby="basic-addon1"
                              type="text"
                              name="company_name"
                              value={formData.company_name || ""}
                              onChange={handleChange}
                              required
                            />
                          </div>

                          <div className="wrapper_input">
                            <div className="jobTitle">Location: </div>
                            <Form.Control
                              className="inputField"
                              placeholder={job.location}
                              aria-label="name"
                              aria-describedby="basic-addon1"
                              type="text"
                              name="location"
                              value={formData.location || ""}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="wrapper_input">
                            <div className="jobTitle">Number Of Openings: </div>
                            <Form.Control
                              className="inputField"
                              placeholder={job.openings}
                              aria-label="name"
                              aria-describedby="basic-addon1"
                              type="text"
                              name="openings"
                              value={formData.openings || ""}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="wrapper_input">
                            <div className="jobTitle">Title: </div>
                            <Form.Control
                              className="inputField"
                              placeholder={job.post}
                              aria-label="name"
                              aria-describedby="basic-addon1"
                              type="text"
                              name="post"
                              value={formData.post || ""}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="wrapper_input">
                            <div className="jobTitle">Mode of Work: </div>
                            <Form.Select
                              className="inputField"
                              aria-label="Mode of Work"
                              aria-describedby="basic-addon1"
                              name="remote"
                              value={formData.remote || ""}
                              onChange={handleChange}
                              required
                            >
                              <option value="">Select mode of work</option>
                              <option value="remote">Remote</option>
                              <option value="hybrid">Hybrid</option>
                              <option value="onsite">Onsite</option>
                            </Form.Select>
                          </div>
                          <div className="wrapper_input">
                            <div className="jobTitle">Salary Offered: </div>
                            <Form.Control
                              className="inputField"
                              placeholder={job.salary_offered}
                              aria-label="name"
                              aria-describedby="basic-addon1"
                              type="text"
                              name="salary_offered"
                              value={formData.salary_offered || ""}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="wrapper_input">
                            <div className="jobTitle">
                              Years Of Experience:{" "}
                            </div>
                            <Form.Control
                              className="inputField"
                              placeholder={job.years_of_experience}
                              aria-label="years_of_experience"
                              aria-describedby="basic-addon1"
                              type="text"
                              name="years_of_experience"
                              value={formData.years_of_experience || ""}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="wrapper_input">
                            <div className="jobTitle">Status: </div>
                            <Form.Select
                              className="inputField"
                              aria-label="Status"
                              aria-describedby="basic-addon1"
                              name="status"
                              value={formData.status || ""}
                              onChange={handleChange}
                              required
                            >
                              <option value="">Select status</option>
                              <option value="active">Active</option>
                              <option value="closed">Closed</option>
                              <option value="draft">Draft</option>
                            </Form.Select>
                          </div>
                          {/* <div className="wrapper_input">
                          <div className="jobTitle">Keywords: </div>
                          <Form.Control
                            className="inputField"
                            placeholder={job.keywords}
                            aria-label="keywords"
                            aria-describedby="basic-addon1"
                            type="text"
                            name="keywords"
                            value={formData.keywords || ""}
                            onChange={handleChange}
                            required
                          />
                        </div> */}

                          <div className="wrapper_input">
                            <div className="jobTitle">Keywords: </div>
                            <div id="skill-container">
                              {selectedKeywords.map((keyword) => (
                                <button
                                  key={keyword}
                                  className={
                                    clickedKeywords.includes(keyword)
                                      ? "highlighted"
                                      : "nothighlighted"
                                  }
                                  onClick={(event) =>
                                    handleKeywordClick(event, keyword)
                                  }
                                >
                                  {keyword}
                                </button>
                              ))}
                            </div>
                            {addnewkeyword && (
                              <>
                                <Form.Control
                                  className="inputField"
                                  // placeholder={job.skills}
                                  placeholder="Add Keyword"
                                  aria-label="name"
                                  aria-describedby="basic-addon1"
                                  type="text"
                                  name="keywords"
                                  value={formData.keywords || ""}
                                  onChange={handleChange}
                                  required
                                />
                              </>
                            )}
                            <div>
                              {addnewkeyword && (
                                <>
                                  <button
                                    className="notSelected"
                                    onClick={handleKeywordPostData}
                                  >
                                    &#10003;
                                  </button>
                                  <button
                                    className="notSelected"
                                    onClick={(event) => {
                                      event.preventDefault();
                                      setAddnewkeyword(false);
                                    }}
                                  >
                                    &#10007;
                                  </button>
                                </>
                              )}
                              <button
                                className="notSelected"
                                onClick={(event) => {
                                  event.preventDefault();
                                  setAddnewkeyword(true);
                                }}
                              >
                                Add Keyword
                              </button>
                            </div>
                          </div>

                          <div className="wrapper_input">
                            <div className="jobTitle">Skills: </div>
                            <div id="skill-container">
                              {selectedSkills.map((skill) => (
                                <button
                                  key={skill}
                                  className={
                                    clickedSkills.includes(skill)
                                      ? "highlighted"
                                      : "nothighlighted"
                                  }
                                  onClick={(event) =>
                                    handleSkillClick(event, skill)
                                  }
                                >
                                  {skill}
                                </button>
                              ))}
                            </div>
                            {addnewskill && (
                              <>
                                <Form.Control
                                  className="inputField"
                                  // placeholder={job.skills}
                                  placeholder="Add Skill"
                                  aria-label="name"
                                  aria-describedby="basic-addon1"
                                  type="text"
                                  name="skills"
                                  value={formData.skills || ""}
                                  onChange={handleChange}
                                  required
                                />
                              </>
                            )}
                            <div>
                              {addnewskill && (
                                <>
                                  <button
                                    className="notSelected"
                                    onClick={handleSkillPostData}
                                  >
                                    &#10003;
                                  </button>
                                  <button
                                    className="notSelected"
                                    onClick={(event) => {
                                      event.preventDefault();
                                      setAddnewskill(false);
                                    }}
                                  >
                                    &#10007;
                                  </button>
                                </>
                              )}
                              <button
                                className="notSelected"
                                onClick={(event) => {
                                  event.preventDefault();
                                  setAddnewskill(true);
                                }}
                              >
                                Add Skill
                              </button>
                            </div>
                          </div>

                          <div className="wrapper_input">
                            <div className="jobTitle">Job Description: </div>
                            <Form.Control
                              as="textarea"
                              className="inputField"
                              placeholder={job.job_description}
                              aria-label="name"
                              aria-describedby="basic-addon1"
                              type="text"
                              style={{ height: "150px" }}
                              name="job_description"
                              value={formData.job_description || ""}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </InputGroup>
                        {/* <div className="center">
                        <button
                          className="submitButton"
                          onClick={() => handleCancelClick(job.job_id)}
                        >
                          Cancel
                        </button>
                        <button className="submitButton" type="submit">
                          Submit
                        </button>
                      </div> */}
                      </div>
                      <div className="center">
                      <button
                        className="submitButton"
                        onClick={() => handleCancelClick(job.job_id)}
                      >
                        Cancel
                      </button>
                      <button className="submitButton" type="submit">
                        Submit
                      </button>
                    </div>
                    </Form>
                  </>
                ) : (
                  <>
                    <div className="allInputField">
                      <InputGroup className="mb-3">
                        <div className="wrapper_input">
                          <div className="jobTitle">Company Name: </div>
                          <Form.Control
                            className="inputField"
                            placeholder={job.company_name}
                            aria-describedby="basic-addon1"
                            type="text"
                            aria-label="name"
                            name="company_name"
                            disabled
                          />
                        </div>

                        <div className="wrapper_input">
                          <div className="jobTitle">Location: </div>
                          <Form.Control
                            className="inputField"
                            placeholder={job.location}
                            aria-describedby="basic-addon1"
                            type="text"
                            aria-label="name"
                            name="location"
                            disabled
                          />
                        </div>
                        <div className="wrapper_input">
                          <div className="jobTitle">Number Of Openings: </div>
                          <Form.Control
                            className="inputField"
                            placeholder={job.openings}
                            aria-label="name"
                            aria-describedby="basic-addon1"
                            type="text"
                            name="openings"
                            disabled
                          />
                        </div>
                        <div className="wrapper_input">
                          <div className="jobTitle">Title: </div>
                          <Form.Control
                            className="inputField"
                            placeholder={job.post}
                            aria-label="name"
                            aria-describedby="basic-addon1"
                            type="text"
                            name="post"
                            disabled
                          />
                        </div>
                        <div className="wrapper_input">
                          <div className="jobTitle">Mode of Work: </div>
                          <Form.Control
                            className="inputField"
                            placeholder={job.remote}
                            aria-label="name"
                            aria-describedby="basic-addon1"
                            type="text"
                            name="remote"
                            disabled
                          />
                        </div>
                        <div className="wrapper_input">
                          <div className="jobTitle">Salary Offered: </div>
                          <Form.Control
                            className="inputField"
                            placeholder={job.salary_offered}
                            aria-label="name"
                            aria-describedby="basic-addon1"
                            type="text"
                            name="salary_offered"
                            disabled
                          />
                        </div>
                        <div className="wrapper_input">
                          <div className="jobTitle">Years Of Experience: </div>
                          <Form.Control
                            className="inputField"
                            placeholder={job.years_of_experience}
                            aria-label="years_of_experience"
                            aria-describedby="basic-addon1"
                            type="text"
                            name="years_of_experience"
                            disabled
                          />
                        </div>
                        <div className="wrapper_input">
                          <div className="jobTitle">Status: </div>
                          <Form.Control
                            className="inputField"
                            placeholder={job.status}
                            aria-label="name"
                            aria-describedby="basic-addon1"
                            type="text"
                            name="status"
                            disabled
                          />
                        </div>
                        <div className="wrapper_input">
                          <div className="jobTitle">Keywords: </div>
                          <Form.Control
                            className="inputField"
                            placeholder={job.keywords}
                            aria-label="keywords"
                            aria-describedby="basic-addon1"
                            type="text"
                            name="keywords"
                            disabled
                          />
                        </div>
                        <div className="wrapper_input">
                          <div className="jobTitle">Skills: </div>
                          <Form.Control
                            className="inputField"
                            placeholder={job.skills}
                            aria-label="name"
                            aria-describedby="basic-addon1"
                            type="text"
                            name="skills"
                            disabled
                          />
                        </div>

                        <div className="wrapper_input">
                          <div className="jobTitle">Job Description: </div>
                          <Form.Control
                            as="textarea"
                            className="inputField"
                            placeholder={job.job_description}
                            aria-describedby="basic-addon1"
                            type="text"
                            style={{ height: "150px" }}
                            aria-label="name"
                            name="job_description"
                            disabled
                          />
                        </div>
                      </InputGroup>
                    </div>
                  </>
                )
              ) : (
                <div>Loading...</div>
              )}
            </div>
          </div>
          {/* {candidate && candidate.length > 0 && (
            <>
              <div className="center dashboardCandidate">Candidates Detail</div>
              <div className="statusButtons">
                <button
                  className={status === "all" ? "active" : ""}
                  onClick={() => handleStatusChange("all")}
                >
                  All Applicants
                </button>
                <button
                  className={status === "shortlisted" ? "active" : ""}
                  onClick={() => handleStatusChange("shortlisted")}
                >
                  Shortlisted
                </button>
                <button
                  className={status === "rejected" ? "active" : ""}
                  onClick={() => handleStatusChange("rejected")}
                >
                  Rejected
                </button>
              </div>
              
              <table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>YOE</th>
                    <th>Date Applied</th>
                    <th>Match Score</th>
                  </tr>
                </thead>
                <tbody>
                  {candidate.map((onecandidate, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          minWidth: "14rem",
                          borderRadius: "10px 0px 0px 10px",
                        }}
                      >
                        {onecandidate.name}
                      </td>
                      <td style={{ minWidth: "14rem" }}>
                        {onecandidate.years_of_experience}
                      </td>
                      <td>{formatDate(onecandidate.createdAt)}</td>
                      <td>{matchScores && matchScores[index]}</td>
                      <td style={{ borderRadius: "0px 10px 10px 0px" }}>
                        <Link
                          to={{
                            pathname: `/dashboard/view_candidate/${onecandidate.user_id}/${job.job_id}`,
                            state: { job: job },
                          }}
                        >
                          <img src={Arrow} alt="Arrow" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )} */}
        </section>
      </div>
    </>
  );
};

export default Viewjobs;
